<template>
  <div class="row" v-on:mousemove="checkInactivityMoveMouse">
    <header-servico
      v-if="is_morph == false"
      tipo="Atendimento"
      :loading="loading"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando Atendimento da Família" />
    <div v-else class="col-md-12">
      <div class="row">
        <sidebar-servicos v-if="is_morph == false" />
        <ModalVerificarPrivado
          :familia-id="familia.id"
          v-if="atendimento.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />
        <div
          v-else
          :class="`${is_morph ? 'col-md-12' : 'col-md-9'}`"
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <div class="row" v-if="is_morph == false">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="col-12 mt-3">
              <h4 class="font-weight-bold">Gestão do Atendimento</h4>
              <div
                class="col-md-12 px-0"
                v-if="
                  atendimento.agendamentos &&
                  atendimento.agendamentos.length > 0
                "
              >
                <div class="alert alert-info">
                  <span v-if="atendimento.agendamentos.length == 1"
                    >Existe
                    {{ atendimento.agendamentos.length }}
                    solicitação de agendamento.</span
                  >
                  <span v-else-if="atendimento.agendamentos.length > 1"
                    >Existem
                    {{ atendimento.agendamentos.length }}
                    solicitações de agendamentos.</span
                  >

                  <a
                    class="router-link-exact-active active d-block"
                    @click="solicitacoesAgendamentos = true"
                    href="#agendamentos"
                  >
                    <i class="mdi mdi-calendar-clock"></i>
                    Mais detalhes
                  </a>
                </div>
              </div>
            </div>
            <HeaderAtendimento :atendimento="atendimento" />
            <div class="row px-3">
              <div class="col-sm-12 col-md-3" v-for="aba in abas" :key="aba.id">
                <a
                  class="btn btn-sm btn-block d-flex align-items-center"
                  role="tab"
                  @click="
                    aba.page == 'reload' ? getAtendimento() : (page = aba.page)
                  "
                  :class="page == aba.page ? 'btn-primary' : 'btn-default'"
                  :title="aba.title"
                >
                  <i :class="aba.icon"></i> {{ aba.title }}
                </a>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="tab-content">
                <div
                  class="animate__animated animate__fadeIn"
                  v-show="page == 'detalhe'"
                >
                  <div class="row">
                    <form-select
                      v-if="
                        verificarTipo(atendimento.tipo_id, 'ABORDAGEM SOCIAL')
                      "
                      v-model="atendimento.situacao_abordagem_social"
                      grid="12"
                      label="Situação Identificada na Abordagem Social"
                      :itens="$root.arrays.situacao_abordagem_social"
                      :required="true"
                      @change="verficaAbordagem"
                      :multiple="true"
                    />
                    <form-input
                      v-if="campoExtra"
                      v-model="atendimento.outra_situacao_abordagem_social"
                      grid="12"
                      label="Digite a outra Situação Identificada na Abordagem Social"
                      :required="true"
                    />
                    <form-select
                      v-model="atendimento.tipo_servico_id"
                      label="Serviço"
                      :itens="servicos"
                    />
                    <form-select
                      v-model="atendimento.local"
                      label="Local de Atendimento"
                      grid="12"
                      :itens="$root.arrays.atendimento_local"
                    />

                    <form-select
                      v-model="atendimento.outra_unidade_id"
                      label="Outra Unidade"
                      grid="12"
                      :itens="outrasunidades"
                      v-if="atendimento.local == 4"
                    />

                    <form-input
                      v-if="atendimento.outra_unidade_id == 9999"
                      v-model="atendimento.outra_unidade_nome"
                      grid="12"
                      label="Digite o nome da outra Unidade"
                      :required="true"
                    />
                    <form-calendar
                      v-model="atendimento.data_cadastro"
                      grid="4"
                      label="Data do Atendimento"
                      :required="true"
                      ajuda="Data que o Atendimento foi realizado"
                      :max-date="dataNow"
                    />
                    <div 
                      class="col-md-6"
                        v-if="verificarTipo(atendimento.tipo_id, 'ESCUTA ESPECIALIZADA')"
                    >
                      <form-toggle
                        label="A Ficha SINAN foi preenchida?"
                        v-model="atendimento.ficha_sinan"
                        ajuda="Caso o profissional opte pelo preenchimento, poderá acessá-la pelo portal SINAN federal. Link: https://portalsinan.saude.gov.br/images/documentos/Agravos/via/violencia_v5.pdf"
                      />
                      <div class="row">
                        <div class="col-auto">Não</div>
                        <div class="col-auto">Sim</div>
                      </div>
                    </div>
<!--                    <form-calendar-->
<!--                      v-model="atendimento.data_prevista"-->
<!--                      grid="4"-->
<!--                      label="Data do Agendamento"-->
<!--                      :min-date="dataNow"-->
<!--                    />-->
<!--                    <form-calendar-->
<!--                      v-model="atendimento.hora_prevista"-->
<!--                      grid="4"-->
<!--                      label="Hora do Agendamento"-->
<!--                      mode="time"-->
<!--                    />-->
                    <form-textarea-editor
                      v-model="atendimento.descricao_sumaria"
                      label="Descrição sumária do Atendimento"
                    />
                  </div>
                  <search-tecnico :tecnicos.sync="atendimento.tecnicos" />
                  <div class="row">
                    <form-select
                      v-model="atendimento.vulnerabilidades"
                      label="Vulnerabilidades"
                      :multiple="true"
                      :itens="vulnerabilidades"
                    />
                  </div>

                  <div class="row d-flex align-items-center">
                    <form-select
                      v-model="atendimento.status"
                      label="Status"
                      grid="4"
                      :itens="status"
                      @change="verificarStatus"
                      :ajuda="ajuda_status"
                    />
                    <form-toggle
                      grid="3"
                      class="mt-4"
                      v-model="atendimento.privado"
                      label="Sigilo?"
                    />
                  </div>
                  <div class="row pt-4 px-0 d-flex justify-content-end">
                    <div class="col-auto px-2 text-right">
                      <a
                        v-if="is_morph"
                        class="btn btn-default"
                        @click="$emit('voltar')"
                      >
                        <i class="mdi mdi-arrow-left" />
                      </a>
<!--                      <a-->
<!--                        class="router-link-exact-active active px-3"-->
<!--                        @click="solicitacoesAgendamentos = true"-->
<!--                      >-->
<!--                        <i class="mdi mdi-calendar-clock"></i>-->
<!--                        Solicitação de Agendamento-->
<!--                      </a>-->
                      <b-button
                        :title="$t('Visualizar e Imprimir')"
                        :to="'/dashboard/atendimentos/show/' + atendimento.id"
                        class="py-1"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                      >
                        <i class="mdi mdi-printer mdi-18px" />
                      </b-button>
                      <a
                        v-if="
                          $store.state.user.role_details.name == 'Admin' ||
                          $store.state.user.role_details.name == 'Gestor(a)' ||
                          $store.state.user.id == atendimento.user_id
                        "
                        title="Remanejar"
                        class="btn btn-warning py-2"
                        @click="$bvModal.show('modal-remanejar-atendimento')"
                      >
                        <i class="fas fa-exchange-alt mdi-18px" />
                        {{ $t("Remanejar") }}
                      </a>
                      <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                        @click="submit"
                      >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                      </button>
                    </div>
                  </div>

                  <!-- Área de Solicitações de Agendamentos -->
                  <div
                    class="col-md-12"
                    v-if="solicitacoesAgendamentos"
                    id="agendamentos"
                  >
                    <Agendamentos
                      :agendamentos="atendimento.agendamentos"
                      @voltar="solicitacoesAgendamentos = false"
                      @reload="
                        getAtendimento(), (solicitacoesAgendamentos = true)
                      "
                    />
                  </div>
                  <!-- Área de Solicitações de Agendamentos -->
                </div>
                <div
                  class="animate__animated animate__fadeIn"
                  v-show="page == 'anexo'"
                >
                  <div class="row">
                    <form-file
                      grid="12"
                      @submit="submitFile"
                      multiple
                      btn-text="Iniciar"
                      label="Enviar Anexos"
                      :progress="progressCompleted"
                    />
                  </div>
                  <anexos
                    :anexos="atendimento.anexos"
                    title="Lista de anexos associados ao ofício"
                  />
                </div>
                <div
                  class="animate__animated animate__fadeIn pb-4"
                  v-show="page == 'outros_usuarios'"
                >
                  <RelacionarUsuarios :atendimentoId="atendimento.id" />
                </div>
                <div
                  class="animate__animated animate__fadeIn"
                  v-show="page == 'comentario'"
                >
                  <modulo-comentario
                    module="Atendimento"
                    :id="atendimento.id"
                  />
                </div>
                <div
                  class="animate__animated animate__fadeIn"
                  v-if="page == 'history'"
                >
                  <div class="row nav nav-tabs mb-3">
                    <a
                      class="nav-link px-3"
                      :class="historicoStatus ? 'bg-primary' : ''"
                      @click="
                        historicoRemanejamento = false;
                        historicoStatus = true;
                      "
                    >
                      <i class="fas fa-history"></i>
                      Histórico de Status
                    </a>
                    <a
                      v-if="
                        atendimento.historico_remanejamento &&
                        atendimento.historico_remanejamento.length > 0
                      "
                      class="nav-link px-3"
                      :class="historicoRemanejamento ? 'bg-primary' : ''"
                      @click="
                        historicoRemanejamento = true;
                        historicoStatus = false;
                      "
                    >
                      <i class="fas fa-history"></i>
                      Histórico de Remanejamento
                    </a>
                  </div>
                  <div class="row">
                    <HistoricoStatus
                      v-show="historicoStatus"
                      @voltar="historicoStatus = false"
                      :id="atendimento.id"
                      :familia="atendimento.familia_id"
                      :status="status_finais"
                    />
                    <HistoricoRemanejamento
                      v-show="historicoRemanejamento"
                      @voltar="historicoRemanejamento = false"
                      :atendimento="atendimento"
                    />
                  </div>
                </div>
                <div
                  class="animate__animated animate__fadeIn"
                  v-if="page == 'auditoria'"
                >
                  <Auditoria
                    @voltar="historicoStatus = false"
                    :id="atendimento.id"
                    :vulnerabilidades="vulnerabilidades"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <status-historico
      modulo="Atendimento"
      titulo_modulo="ATENDIMENTO"
      :model="model"
      :id="atendimento.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_finais"
      @submit="submit"
    />
    <remanejar-atendimento :atendimento="atendimento" />
  </div>
</template>
<script>
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import Auditoria from "./includes/Auditoria.vue";
import HistoricoStatus from "./HistoricoStatus";
import HistoricoRemanejamento from "./HistoricoRemanejamento";
import HeaderAtendimento from "./HeaderAtendimento";
import RelacionarUsuarios from "./pages/RelacionarUsuarios.vue";
import Agendamentos from "./includes/SolictacoesAgendamento";
export default {
  components: {
    ModalVerificarPrivado,
    HistoricoStatus,
    HistoricoRemanejamento,
    HeaderAtendimento,
    Auditoria,
    RelacionarUsuarios,
    Agendamentos,
  },
  name: "Edit",
  props: ["morph", "morphAtendimentoId"],
  data() {
    return {
      status: {},
      status_finais: [],
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: true,
      historicoRemanejamento: false,
      solicitacoesAgendamentos: false,
      vulnerabilidades: {},
      atendimento: {},
      tecnicos: {},
      unidades: {},
      tipos: [],
      servicos: {},
      familia: {},
      files: {},
      loading: true,
      loadServicos: false,
      progressCompleted: 0,
      status_privado: false,
      inativo: false,
      is_morph: false,
      model: "Atendimento",
      user_id: null,
      loadingTecnicos: true,
      dataNow: moment().format("YYYY/MM/DD"),
      campoExtra: false,
      tecnicos_selected: null,
      tecnico_temp: "",
      unidade: "",
      loading_tecnicos: false,
      page: "detalhe",
      abas: [
        {
          id: 1,
          title: "DETALHES",
          page: "detalhe",
          icon: "mdi mdi-format-list-text mdi-18px mr-2",
        },
        {
          id: 2,
          title: "USUÁRIOS RELACIONADOS",
          page: "outros_usuarios",
          icon: "mdi mdi-account-multiple mdi-18px mr-2",
        },
        {
          id: 3,
          title: "ANEXOS",
          page: "anexo",
          icon: "mdi mdi-paperclip mdi-18px mr-2",
        },
        {
          id: 4,
          title: "COMENTÁRIO",
          page: "comentario",
          icon: "mdi mdi-comment-text-multiple mdi-18px mr-2",
        },
        {
          id: 5,
          title: "HISTÓRICO DE STATUS",
          page: "history",
          icon: "mdi mdi-history mdi-18px mr-2",
        },
        {
          id: 6,
          title: "AUDITORIA",
          page: "auditoria",
          icon: "mdi mdi-timeline-clock-outline mdi-18px mr-2",
        },
      ],
      ajuda_status: `<b>ABERTO:</b> O status aberto é indicado sempre que o usuário da plataforma registra um atendimento, no caso esse status aponta que foi iniciado um registro, e está em processo de cadastramento para gerenciamento e indicação de outros status ( continuidade da intervenção);<br><br>
      <b>DEMANDA REPRIMIDA:</b> O status demanda reprimida é indicado sempre que o Usuário da Plataforma registra no ícone Atendimento, demanda apresentado por usuário da política pública de Assistência Social, que apesar de ter registrado seu atendimento, entra como demanda reprimida, pois não será dado continuidade na intervenção, em razão de falta de recursos humanos, estruturais, etc, que impedem o atendimento pela Equipe Técnica de Referência da Unidade do SUAS naquele momento;<br><br>
      <b>EM ANDAMENTO:</b> O status Em Andamento é indicado sempre que o usuário da Plataforma registra um atendimento e ao gerenciar a intervenção de aberto para em Andamento indica se esse seria o primeiro atendimento, ou outros atendimentos, além de registrar após avaliação técnica a continuidade do procedimento, para inserção nos serviços da Proteção Social Básica (PSB) ou Proteção Social Especial (PSE), e naquele momento a gestão do atendimento fica em andamento.<br><br>
      <b>atendimento:</b> O status atendimento é indicado sempre que o usuário da Plataforma, após gerenciar um atendimento realizado, verifica a necessidade de atendimento do grupo familiar/usuário para andamento e articulação da situação identificada, para serviços, programas e projetos da rede intersetorial, ou para acesso a benefícios de acordo a avaliação técnica realizada;<br><br>
      <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar um atendimento realizado, atualiza o status para finalizado informando os motivos pelo qual está encerrando o atendimento. Os motivos podem ser: retorno para cidade de origem (recambio), não adesão ao serviço; mudança de endereço (referenciamento); mudança de cidade; óbito, encaminhando para outro serviço, atendimento concluído, e outros motivos que culminaram na finalização do atendimento.<br><br>
      <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`,
    };
  },
  mounted() {
    this.morph ? (this.is_morph = true) : (this.is_morph = false);

    this.getInformacaoCampos();
    this.$bvModal.show("verificar-atendimento-privado");
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-atendimento-privado");
      }
      return this.$root.isIdle;
    },
    unidade_tecnicos() {
      this.loading_tecnicos = true;
      const pessoas = this.tecnicos;
      let tecnicos = [];
      pessoas.map((elem) => {
        if (elem.id_unidade == this.unidade) {
          tecnicos.push({
            id: elem.id,
            value: " <b>" + elem.value + "</b>",
          });
        }
      });
      setTimeout(() => {
        this.loading_tecnicos = false;
      }, 1000);

      this.tecnico_temp = null;
      return tecnicos;
    },
  },
  methods: {
    listTecnicosSelected() {
      if (this.atendimento.tecnicos.length > 0) {
        const pessoas = this.atendimento.tecnicos;
        let tecnicos = [];
        if (this.tecnicos) {
          pessoas.map((elem) => {
            let temp = this.tecnicos.find((item) => {
              return item.id == elem;
            });

            if (temp) {
              tecnicos.push({
                id: temp.id,
                value: " <b>" + temp.value + "</b> - " + temp.nome_unidade,
              });
            }
          });
        }
        this.tecnicos_selected = tecnicos.length > 0 ? tecnicos : null;
      } else {
        this.tecnicos_selected = null;
      }
      this.tecnico_temp = null;
    },
    setTecnicoParticipante() {
      if (this.atendimento.tecnicos == null) {
        this.atendimento.tecnicos = [this.tecnico_temp];
      } else {
        this.atendimento.tecnicos.push(this.tecnico_temp);
      }
      this.clearTecnicoTemp();
      this.listTecnicosSelected();
    },
    clearTecnicoTemp() {
      this.$refs.selecttecnico.item = null;
    },
    getInformacaoCampos() {
      axios
        .get(`api/dashboard/atendimento/get/imformacao/campo`)
        .then((response) => {
          this.vulnerabilidades = response.data.vunerabilidades;
          this.tipos = response.data.tipos;
          this.denuncias = response.data.denuncias;
          this.servicos = response.data.servicos;
          this.tecnicos = response.data.tecnicos;
          this.unidades = response.data.unidades;
          this.status = response.data.status;
          this.status_finais = response.data.status;

          this.outrasunidades = response.data.unidades;

          this.outrasunidades.push({
            id: 9999,
            value: "Outra",
          });
        }).finally(()=>{

          this.getAtendimento();
        });
    },
    verficaAbordagem(value) {
      value.indexOf(6) >= 0
        ? (this.campoExtra = true)
        : (this.campoExtra = false);
    },
    verificarTipo(tipo, search) {
      const result = this.tipos.filter(
        (item) => item.id == tipo && item.value == search
      );
      return result.length > 0 ? true : false;
    },
    getVulnerabilidades() {
      axios.get(`api/dashboard/get/geral/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data;
      });
    },
    checkInactivityMoveMouse() {
      if (this.atendimento.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-atendimento-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
    submitFile(files) {
      this.files = files;
      let formData = new FormData();

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("files[]", this.files[i]);
        }
      } else {
        formData.append("files", this.files);
      }

      formData.append("id", this.atendimento["id"]);
      formData.append("familia_id", this.atendimento["familia_id"]);

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/atendimento/upload`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.getAtendimento(false);
          ladda.stop();
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
          formData.delete("files");
        });
    },

    getAtendimento(load = true) {
      this.loading = load;
      var id = this.is_morph ? this.morphAtendimentoId : this.$route.params.id;
      axios
        .get(`api/dashboard/atendimentos/${id}`)
        .then((response) => {
          this.atendimento = response.data.data;
          this.statusAnterior = this.atendimento.status;
          this.familia = this.atendimento.familia_id;
          this.$route.query.familia_id = this.atendimento.familia_id.id;
          this.statusAnterior = this.atendimento.status;

          this.verficaAbordagem(this.atendimento.situacao_abordagem_social);
        })
        .finally(() => {
          this.loading = false;
          this.listTecnicosSelected();
        })
        .catch((error) => {
          this.$router.push(
            "/dashboard/atendimentos/" + this.$route.query.familia_id
          );
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br><br>" + error,
            icon: "error",
          });
        });
    },

    verificarStatus(status) {
      this.statusAtual = status;

      const result = this.status_finais.filter((item) => item.id == status);
      if (result[0].final == 1) {
        this.$bvModal.show("status-historico-" + this.model);
      }
    },

    submit() {
      this.atendimento.familia_id = this.familia.id;

      if (this.atendimento.data_cadastro) {
        this.atendimento.data_cadastro = this.$options.filters.formatDateYMD(
          this.atendimento.data_cadastro
        );
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(`api/dashboard/update/atendimentos`, {
          atendimento: this.atendimento,
          status: this.status,
        })
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.getAtendimento();
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
